import loadApp from "~/apps/BaseApp/loadApp";
import Main from "~/apps/Main";

loadApp(Main);
